export default "__VITE_ASSET__CHaF3Hn2__";